module.exports = __webpack_public_path__ + "static/media/Tartaglia.1a710c1f.png";